import { useAppSelector } from "@/app_redux/hooks/root_hook";
import DayClosingFilterComponent from "../DayClosingFilterComponent";
import { useDayClosingCurrentShift } from "@/app/hooks/api_hooks/dayClosing/useDayClosingCurrentShift";
import { useEffect } from "react";
import SwitchComponent from "../../OrderManagement/SwicthComponent";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";

const DayClosingHeaderComponent = () => {
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);
  const { execute: fetchCurrentShift, closureData } = useDayClosingCurrentShift();

  useEffect(() => {
    fetchCurrentShift(mappedClinicId);
  }, []);

  const params = new URLSearchParams(location.search);
  const isClinicView = params.get("is_clinic") === "CLINIC";
  const isCentralOpps = useFeatureAccess("ACCOUNTING_CASH_CLOSING_CENTRAL_VIEW");
  const isCentralOppsVisible = isCentralOpps;

  const formatted = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "2-digit" });

  return (
    <div className="w-full bg-white shadow-sm py-3 px-3 sm:px-4 mb-2 rounded-xl">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0">
          <h2 className="text-sm font-semibold text-gray-900 flex items-center gap-2 flex-wrap">
          <span>Day Closing</span>
          <span className="text-lg leading-none">•</span>
          <span>{formatted}</span>
          </h2>

          <p className="text-[#6C727F] text-xs"></p>
        </div>

        <div className="flex flex-col gap-3 w-full lg:w-auto lg:flex-row lg:items-center justify-between lg:justify-end">
          <div className="flex-1 lg:flex-none min-w-0">
            {isCentralOpps && !isClinicView ? (
              <DayClosingFilterComponent />
            ) : (
              <div>
                {closureData?.full_day_open && (
                  <p className="bg-green-200 border border-green-300 px-2 py-0 text-xs capitalize rounded-md font-medium whitespace-nowrap inline-flex justify-center">
                    {closureData?.shift} Shift
                  </p>
                )}
              </div>
            )}
          </div>

          {isCentralOppsVisible && (
            <div className="shrink-0">
              <SwitchComponent />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DayClosingHeaderComponent;
